angular.module('lead')
    .component('clientLeadsTable', {
        bindings: {
            clientId: '<',
            email: '<',
            phone: '<',
            excludeLeadIds: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/lead/client-leads.html',
        controller: function($timeout, Lead, LeadService) {
            const ctrl = this;
            this.LeadService = LeadService;

            this.$onChanges = () => {
                const emails = collectEmails();
                const phones = collectPhones();
                this.relatedMode = !!this.clientId || emails.length > 0 || phones.length > 0;
                this.filters = {
                    clientId: this.clientId,
                    email: emails,
                    phone: phones,
                    excludeLeadIds: this.excludeLeadIds
                };
                this.scheduleLoadData();
            };

            this.scheduleLoadData = () => {
                if (this.debouncePromise) {
                    $timeout.cancel(this.debouncePromise);
                }
                this.debouncePromise = $timeout(() => this.loadData(), this.relatedMode ? 250 : 0);
            };

            this.loadData = () => {
                if(!this.relatedMode) {
                    this.page = null;
                    this.itemsPromise = null;
                    this.onDataLoaded({$page: this.page});
                    return;
                }
                this.page = null;
                const requestId = Date.now();
                this.lastRelatedRequestId = requestId;
                this.itemsPromise = Lead.relatedByContact({
                    clientId: this.filters.clientId,
                    email: this.filters.email,
                    phone: this.filters.phone,
                    excludeLeadIds: this.excludeLeadIds,
                    page: this.filters.page,
                    size: this.filters.size
                }).$promise.then(result => {
                    if (this.lastRelatedRequestId !== requestId) {
                        return;
                    }
                    this.page = result;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                });
            };

            function collectEmails() {
                const emails = [];
                addUnique(emails, trim(ctrl.email).toLowerCase());
                return emails;
            }

            function collectPhones() {
                const phones = [];
                addUnique(phones, trim(ctrl.phone));
                return phones;
            }

            function addUnique(items, value) {
                if (value && items.indexOf(value) < 0) {
                    items.push(value);
                }
            }

            function trim(value) {
                return value === null || angular.isUndefined(value) ? '' : String(value).trim();
            }
        }
    });
